import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-themighty',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>The Mighty icon</title><path d="M19.178.001h-4.432L12.05 13.988 9.309.001H4.856c.216.219.334.634.39 1.072v21.21c0 .621-.105 1.383-.425 1.717 1.014-.214 2.307-.416 3.414-.611V9.375l2.489 12.375c.07.46.135 1.084-.021 1.198.847-.129 1.694-.252 2.544-.366-.105-.16-.064-.652-.005-1.061L15.696 9.15v13.095c1.054-.123 2.366-.24 3.47-.349l.012-.008c-.324-.328-.43-1.1-.43-1.724V1.726c0-.627.105-1.396.43-1.726v.001z"/></svg>`,
    styles: []
})
export class SimpleIconsThemightyComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#D0072A';
    @Input() className: string = 'simple-icons-themighty'
    constructor() {}
    ngOnInit(): void {}
}
